// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3FgNa","rightAdornment":"Header_rightAdornment__3nV1Z"};